var map = {
	"./box2-img.png": "aac5",
	"./box3-img.png": "4d7f",
	"./box4-img.png": "6862",
	"./box5-img.png": "b128",
	"./box6-img.png": "cda9",
	"./box7-img.png": "6cfd",
	"./box8-img.png": "12da",
	"./box9-img.png": "e67e",
	"./characteristics-box1-img.png": "0bef",
	"./chat-bottom-bg.png": "f1bd",
	"./chat-loop/1-1-en.png": "68df",
	"./chat-loop/1-1.png": "8e9b",
	"./chat-loop/1-2-en.png": "599c",
	"./chat-loop/1-2.png": "1f7b",
	"./chat-loop/1-3-en.png": "3c09",
	"./chat-loop/1-3.png": "9b1c",
	"./chat-loop/2-1-en.png": "debd",
	"./chat-loop/2-1.png": "c40a",
	"./chat-loop/2-2-en.png": "2813",
	"./chat-loop/2-2.png": "38c6",
	"./chat-loop/2-3-en.png": "1efe",
	"./chat-loop/2-3.png": "3a24",
	"./chat-loop/3-1-en.png": "44b2",
	"./chat-loop/3-1.png": "4861",
	"./chat-loop/3-2-en.png": "109a",
	"./chat-loop/3-2.png": "8ea0",
	"./chat-loop/3-3-en.png": "d53a",
	"./chat-loop/3-3.png": "78e5",
	"./chat-loop/4-1-en.png": "fac4",
	"./chat-loop/4-1.png": "0d41",
	"./chat-loop/4-2-en.png": "39a9",
	"./chat-loop/4-2.png": "2f4e",
	"./chat-loop/4-3-en.png": "2ad7",
	"./chat-loop/4-3.png": "bdfa",
	"./chat-top-bg.png": "3acd",
	"./dark-homelogo-en.png": "1980",
	"./gpt-icon-min.png": "3b98",
	"./home-box1-bg-light.png": "c02b",
	"./home-box1-bg.png": "8aa0",
	"./home-box1-sandbox-light.png": "21ef",
	"./home-box1-sandbox.png": "be7b",
	"./home-box4-bg.png": "e996",
	"./home-customer-choice-en.png": "d563",
	"./home-customer-choice-light-en.png": "c4db",
	"./home-customer-choice-light.png": "f7b8",
	"./home-customer-choice.png": "c48b",
	"./home-huawei-light.png": "d8d6",
	"./home-huawei.png": "7f67",
	"./home-meituan-light.png": "9789",
	"./home-meituan.png": "e709",
	"./home-midea-light.png": "0891",
	"./home-midea.png": "45733",
	"./home-prc-light.png": "95f9",
	"./home-prc.png": "d75e",
	"./home-product-advantage-en.png": "4454",
	"./home-product-advantage-light-en.png": "a67e",
	"./home-product-advantage-light.png": "20bb",
	"./home-product-advantage.png": "8167",
	"./home-scdx-light.png": "59eb",
	"./home-scdx.png": "fe78",
	"./home-selected-report-en.png": "3e8f",
	"./home-selected-report-light-en.png": "a866",
	"./home-selected-report-light.png": "9ea4",
	"./home-selected-report.png": "160e",
	"./home-service-price-en.png": "d431",
	"./home-service-price-light-en.png": "df9b",
	"./home-service-price-light.png": "c46c",
	"./home-service-price.png": "8ace",
	"./home-servicePrice-mf-light.png": "fe02",
	"./home-servicePrice-mf.png": "bdf1",
	"./home-servicePrice-qy-light.png": "71a7",
	"./home-servicePrice-qy.png": "2c5a",
	"./home-servicePrice-zy-light.png": "4ab5",
	"./home-servicePrice-zy.png": "0285",
	"./home-servicePrice-zyzq-light.png": "e419",
	"./home-servicePrice-zyzq.png": "f895",
	"./home-swiper-1.png": "4988",
	"./home-swiper-2.png": "721d",
	"./home-swiper-3.png": "be6e",
	"./home-swiper-4.png": "d36a",
	"./home-swiper-5.png": "af65",
	"./home-swiper-dot-active.png": "f88f",
	"./home-swiper-dot.png": "b0bb",
	"./home-tab-active.png": "477f",
	"./home-time-logo.png": "a8a3",
	"./home-typical-scenarios-en.png": "341e",
	"./home-typical-scenarios-icon1.png": "2024",
	"./home-typical-scenarios-icon2.png": "5a61",
	"./home-typical-scenarios-icon3.png": "2aa7",
	"./home-typical-scenarios-light-en.png": "e2b6",
	"./home-typical-scenarios-light.png": "a6a8",
	"./home-typical-scenarios.png": "77d5",
	"./home-window-logo.png": "f3d3",
	"./home-wz-light.png": "bd47",
	"./home-wz.png": "e080",
	"./home-yjzx-light.png": "1452",
	"./home-yjzx.png": "8556",
	"./home-zggs-light.png": "1c6d",
	"./home-zggs.png": "266a",
	"./home-zgyd-light.png": "dfdc",
	"./home-zgyd.png": "f488",
	"./home-zhaoshang-light.png": "2065",
	"./home-zhaoshang.png": "9752",
	"./home2-bg.png": "547c",
	"./home2-box2-1.png": "ee9c",
	"./home2-box2-2.png": "c026",
	"./home2-box2-3.png": "cebd",
	"./home2-box2-4.png": "c56f",
	"./home2-box2-5.png": "4a16",
	"./home2-box2-6.png": "cc41",
	"./home3-box3-img1.png": "13ac",
	"./home3-box3-img2.png": "c1f1",
	"./home3-box3-img3.png": "051d",
	"./home3-box3-img4.png": "b7de",
	"./home3-box3-img5.png": "ed4a",
	"./home3-box3-img6.png": "cd5f",
	"./index-box2-0.png": "44b8",
	"./index-box2-1.png": "791c",
	"./index-box2-2.png": "bd72",
	"./index-box2-3.png": "ab14",
	"./index-box2-4.png": "b98f",
	"./index-box2-5.png": "2fce",
	"./light-homelogo-en.png": "20a1",
	"./logo-en.png": "6a45",
	"./ps-0-light.png": "621c",
	"./ps-0.png": "7b62",
	"./ps-1-light.png": "735a",
	"./ps-1.png": "7a1c",
	"./ps-2-light.png": "cc03",
	"./ps-2.png": "095c",
	"./ps-3-light.png": "be06",
	"./ps-3.png": "14cd",
	"./ps-4-light.png": "aba5",
	"./ps-4.png": "52c7",
	"./ps-5-light.png": "8d00",
	"./ps-5.png": "21bb",
	"./swiper-border.png": "c3ef",
	"./swiper-border2.png": "147f",
	"./track-bottom-bg-light.png": "57c7",
	"./track-bottom-bg.png": "cd6b",
	"./track-bottom-text-en.png": "d8bc",
	"./track-bottom-text-light-en.png": "2f40",
	"./track-bottom-text.png": "ce6d",
	"./track-top-bg-light.png": "60ed",
	"./track-top-bg.png": "3949d",
	"./tracked-box1-gap-light.png": "a3b6",
	"./tracked-box1-gap.png": "0cc1",
	"./tracked-tab1.png": "53c6",
	"./tracked-tab2.png": "aacf",
	"./ts-0-light.png": "a143",
	"./ts-0.png": "0974",
	"./ts-1-light.png": "56fc",
	"./ts-1.png": "25fe",
	"./ts-2-light.png": "026e",
	"./ts-2.png": "2c27"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9730";